import { css } from '@mui/material';
import type { MuiTheme } from '@sdb/planning-ui/ui-3/packages/types/src/theme/sx.types';
import type { CSSProperties } from 'react';

export const getBasicActionStyling = (
  theme: MuiTheme,
  override?: CSSProperties
) => {
  return css({
    position: 'relative',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    color: theme.vars.palette.text.primary,
    fontSize: theme.vars.font.button,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    display: 'flex',
    padding: `${theme.spacing(2.5)} ${theme.spacing(2.5)} ${theme.spacing(
      2.5
    )} ${theme.spacing(5)}`,
    width: '100%',
    height: '45px',
    alignItems: 'center',
    borderRadius: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[400]}`,
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    '&:not(:first-child)': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    '&:not(:last-child)': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    },
    '&:hover': {
      backgroundColor: theme.vars.palette.surface.containerHigh
    },
    '&:not(:first-child):not(:only-child)': {
      borderTop: `none`
    },
    ...override
  });
};

export const getSeparatedItemStyling = (theme: MuiTheme) =>
  css({
    marginBlockStart: theme.spacing(2.5),
    borderTop: `1px solid ${theme.palette.grey[400]} !important`,
    borderTopLeftRadius: `${theme.spacing(3)} !important`,
    borderTopRightRadius: `${theme.spacing(3)} !important`
  });

export const getBeforeSeparatedItemStyling = (theme: MuiTheme) =>
  css({
    borderBottomLeftRadius: `${theme.spacing(3)} !important`,
    borderBottomRightRadius: `${theme.spacing(3)} !important`
  });

export const rightClickThroughBackdrops = (
  ev: React.MouseEvent<HTMLElement, MouseEvent>,
  handleClose?: () => void
) => {
  ev.preventDefault();
  ev.stopPropagation();

  toggleBackdropClickHandling(false);

  const target = getRetriggerTarget(ev);
  if (!target) {
    return;
  }

  handleClose?.();

  setTimeout(() => {
    retriggerRightClick(ev.clientX, ev.clientY, target);

    toggleBackdropClickHandling(true);
  });
};

const toggleBackdropClickHandling = (enabled: boolean) => {
  const backdrops = document.querySelectorAll(
    '.MuiBackdrop-root, .MuiModal-root'
  );
  backdrops.forEach((backdrop) => {
    (backdrop as HTMLElement).style.pointerEvents = !enabled ? 'none' : 'unset';
  });
};

const getRetriggerTarget = (ev: React.MouseEvent<HTMLElement, MouseEvent>) => {
  const { clientX, clientY } = ev;
  return document.elementFromPoint(clientX, clientY);
};

const retriggerRightClick = (
  clientX: number,
  clientY: number,
  target: Element
) => {
  const customRightClickEvent = new MouseEvent('contextmenu', {
    bubbles: true,
    cancelable: true,
    button: 2,
    clientX,
    clientY
  });

  target.dispatchEvent(customRightClickEvent);
};
